<template>
  <section class="accordion-item" v-bind:class="{ 'open': isOpen, [variant]: variant }">
    <div class="accordion-header" v-on:click="toggle">
      <slot name="header"></slot>
      <button class="btn-icon" type="button">
        <img v-if="arrowStyle === 'dark'" src="~assets/img/icons/icn_dark_grey_arrow.png" class="img-icn-grey-arrow dark">
        <img v-else src="~assets/img/icons/icn_grey_arrow.svg" class="img-icn-grey-arrow">
      </button>
    </div>
    <div class="accordion-body">
      <template v-if="loading">
        <div class="loading-container">
          <img src="~assets/img/loading-spinner.gif" alt="Loading..." />
        </div>
      </template>
      <template v-else>
        <slot name="body"></slot>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: "Accordion",
  props: {
    title: String,
    idx: [Number, String],
    onOpen: Function,
    onClose: Function,
    variant: String,
    arrowStyle: String,
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    toggle() {
      if (!this.isOpen && this.onOpen) {
        this.onOpen(this.idx);
      }

      this.isOpen = !this.isOpen;
      if (this.title && this.isOpen) {
        this.$helper.sendGA('click_btn_faq_title', { 'target': this.title });
      }
    },
    close() {
      if (this.isOpen && this.onClose) {
        this.onClose(this.idx);
      }

      this.isOpen = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.accordion-header {
  position: relative;
  padding: 25px 0 25px 12px;
  border-bottom: 1px solid #c9c9c9;
  line-height: 100%;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60px;

  img {
    height: 30px;
    opacity: .4;
  }
}

.accordion-body {
  position: relative;
  color: #7f7f7f;
  transition: all .4s ease;
  font-size: 15px;
  line-height: 1.73;
  overflow: hidden;

  max-height: 0px;
  //opacity: 0;
  padding: 0 40px;

  @include respond(mobile) {
    padding: 0 20px;
  }
}

.btn-icon {
  position: absolute;
  right: 36px;
  width: 18px;
  height: 18px;
  font-size: 18px;
  top: 50%;
  color: #000;
  background-color: transparent;
  transition: transform 0.2s ease 0s;
  transform: translateY(-50%);

  img {
    position: absolute;
    width: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.dark {
      width: 11px;
    }
  }

  @include respond(mobile) {
    right: 18px;
    font-size: 14px;

    img {
      width: 5.34px;
    }
  }
}

.accordion-item.open {
  .accordion-body {
    padding-top: 20px;
    padding-bottom: 20px;
    //padding-bottom: 34px;
    max-height: 400px;
    border-bottom: 1px solid #c9c9c9;
    overflow: auto;

    //@include respond(mobile) {
    //  max-height: none;
    //}
  }

  .btn-icon {
    transform: translateY(-50%) rotate(180deg);
  }
}

.accordion-item {
  &.white-bg {
    background-color: #fff;
    border-radius: 5px;

    .accordion-header {
      position: relative;
      border: none;
      padding: 20px;
      font-weight: 800;
    }

    .accordion-body {
      border: none;
    }

    &.open {
      .accordion-header::after {
        content: '';
        display: block;

        position: absolute;
        bottom: 0;
        left: 20px;
        right: 20px;

        height: 1px;
        background-color: #EDEFF2;
      }

      .accordion-body {
        padding: 15px 20px 20px;
      }
    }

    @include respond(mobile) {
      .accordion-header {
        padding: 11px 16px;
        font-size: 13px;
        line-height: 17px;
      }

      &.open {
        .accordion-header::after {
          left: 16px;
          right: 16px;
        }
      }
    }
  }
}
</style>
